export const UNMANAGED_EXPEDIENTE_DETAIL_TABS = Object.freeze([
  "information",
  "actuaciones",
  "documents",
]);

export function isUnmanagedExpedienteDetailTab(tabId) {
  return UNMANAGED_EXPEDIENTE_DETAIL_TABS.includes(tabId);
}
